/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import React from 'react';
import {DescriptionOutlined, AccountCircle, BackupOutlined, RestorePageOutlined, Settings} from '@mui/icons-material'

// Adding Icons from https://material-ui.com/components/material-icons/
import STATIC_ROUTES from '../route/STATIC_ROUTES';
import { ROLES } from '../config';

interface SideBarType {
	SideBarConfig: Object<Array>
}

// eslint-disable-next-line import/prefer-default-export
const SideBarConfig: SideBarType = {
	config: {
		drawerWidth: 250, // 250,
		drawerSide: 'left',
		isSwipeableDrawer: true,
		isAlwaysOpened: false // can be always opened if isSwipeableDrawer is false value
	},
	guest: [
		// { private: false, path: '/login', translate: 'signin', icon: <AccountBoxIcon/>, },
		// { private: false, path: '/signup', translate: 'signup', icon: <AccountBoxIcon/>, },
	],
	menu: [
		// {
		//   private: true,
		//   open: true,
		//   isCollapsed: false,
		//   path: STATIC_ROUTES.homepage,
		//   translate: 'home',
		//   icon: null,
		//   accessRole: [ROLES.SUPER_ADMIN, ROLES.PARTNER, ROLES.ADMIN_DASHBOARD_MANAGER, ROLES.ADMIN, ROLES.MANAGER, ROLES.OBSERVER]
		// },
		{
			private: true,
			open: true,
			isCollapsed: false,
			isLinkDisabled: false,
			path: STATIC_ROUTES.projects,
			translate: 'dashboard',
			icon: <BackupOutlined/>,
			accessRole: [ROLES.SUPER_ADMIN, ROLES.USER],
		},
		{
			private: true,
			open: true,
			isCollapsed: false,
			isLinkDisabled: false,
			path: STATIC_ROUTES.projects,
			translate: 'projects',
			icon: <RestorePageOutlined/>,
			accessRole: [ROLES.SUPER_ADMIN, ROLES.USER],
			// children: [
			//   {
			//     private: true,
			//     isSelected: false,
			//     path: STATIC_ROUTES.projects,
			//     translate: 'archive',
			//     icon: null,
			//     accessRole: [ROLES.SUPER_ADMIN,  ROLES.USER]
			//   },
			//   {
			//     private: true,
			//     isSelected: false,
			//     path: STATIC_ROUTES.projects,
			//     translate: 'Verwalten',
			//     icon: null,
			//     accessRole: [ROLES.SUPER_ADMIN, ROLES.USER]
			//   },
			// ]
		},
		{
			private: true,
			open: true,
			isCollapsed: false,
			isLinkDisabled: false,
			path: STATIC_ROUTES.projects,
			translate: 'calibration',
			icon: <DescriptionOutlined/>,
			accessRole: [ROLES.SUPER_ADMIN, ROLES.USER],
		},
		{
			private: true,
			open: true,
			isCollapsed: false,
			translate: 'profileSettings',
			path: STATIC_ROUTES.projects,
			icon: <AccountCircle/>,
			accessRole: [ROLES.SUPER_ADMIN, ROLES.USER],
		},
		{
			private: true,
			open: true,
			isCollapsed: false,
			translate: 'administration',
			path: STATIC_ROUTES.admin,
			icon: <Settings/>,
			accessRole: [ROLES.SUPER_ADMIN],
		}
	]
};

export default SideBarConfig;
